/**
 * 获取留言
 * @author Kody
 * @see http://api.umucdn.cn/project/232/interface/api/4325
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

interface IInput {
    is_elite: number; // 0 | 1;
    to_umu_id: string;
    size: number;
    page: number;
}

export interface IOutput {
    list: IProfileMessage[];
    page_info: IPageInfo & { has_unread: boolean };
}

export const getProfileMessage = (param: IInput): Promise<IResponse<IOutput>> => {
    return fetchData(Api.PROFILE_MESSAGES, param);
};
